import { useCompanyHeader } from '@/data-table-configs/companies';
import { useCustomerHeader } from '@/data-table-configs/customers';
import {
  CUSTOMER_QUERY_DOMAIN,
  customerQueryDateRangeDic,
  customerQueryDomainDic,
} from '@/types/customerConst';
import { ACCOUNT_COLUMNS, CONTACT_COLUMNS } from '@/types/filterKeyConst';

export const useRangeSelect = () => {
  return Object.entries(customerQueryDateRangeDic).map(([key, value]) => {
    return {
      value: Number(key),
      label: value,
    };
  });
};

export const useDomainSelect = () => {
  return [
    {
      value: CUSTOMER_QUERY_DOMAIN.ACCOUNT,
      label: customerQueryDomainDic[CUSTOMER_QUERY_DOMAIN.ACCOUNT],
    },
    {
      value: CUSTOMER_QUERY_DOMAIN.CONTACT,
      label: customerQueryDomainDic[CUSTOMER_QUERY_DOMAIN.CONTACT],
    },
  ];
};

export const useSegmentSelect = (
  domain: CUSTOMER_QUERY_DOMAIN,
): {
  value: string;
  label: string;
}[] => {
  if (domain === CUSTOMER_QUERY_DOMAIN.ACCOUNT) {
    return [
      {
        value: ACCOUNT_COLUMNS.INDUSTRY,
        label: 'Industry',
      },
      {
        value: ACCOUNT_COLUMNS.COUNTRY,
        label: 'Country',
      },
      {
        value: ACCOUNT_COLUMNS.RATING,
        label: 'Rating',
      },
      {
        value: ACCOUNT_COLUMNS.SIZE,
        label: 'Size',
      },
      {
        value: ACCOUNT_COLUMNS.PLAN,
        label: 'Plan',
      },
      {
        value: ACCOUNT_COLUMNS.TYPE,
        label: 'Type',
      },
      {
        value: ACCOUNT_COLUMNS.PRIMARY_USECASE,
        label: 'Primary usecase',
      },
      {
        value: ACCOUNT_COLUMNS.STAGE,
        label: 'Stage',
      },
    ];
  }
  if (domain === CUSTOMER_QUERY_DOMAIN.CONTACT) {
    return [
      {
        value: CONTACT_COLUMNS.PLAN,
        label: 'Plan',
      },
      {
        value: CONTACT_COLUMNS.STAGE,
        label: 'Stage',
      },
      {
        value: CONTACT_COLUMNS.TYPE,
        label: 'Type',
      },
      {
        value: CONTACT_COLUMNS.COUNTRY,
        label: 'Country',
      },
    ];
  }
  return [];
};

export const useSegmentValueOptions = (segment?: string) => {
  const accountColumns = useCompanyHeader();
  const contactColumns = useCustomerHeader();

  const fullCols = [...(accountColumns || []), ...(contactColumns || [])];

  if (!segment) return null;
  return fullCols.find((col) => col.columnKey === segment) || null;
};
